


























































































import { Component, Vue } from "vue-property-decorator";
import ComparisonButton from "@/components/ComparisonButton.vue"; // @ is an alias to /src
import CategoriesDataService, {
  CategorySelectorRow
} from "@/services/CategoriesDataService";
import StateContainer, { State } from "@/components/StateContainer.vue";
import LoadingTable from "@/components/LoadingTable.vue";
import BaseTable from "@/components/BaseTable.vue";

@Component({
  components: { BaseTable, LoadingTable, StateContainer, ComparisonButton }
})
export default class Categories extends Vue {
  private categoriesState = State.loading;
  private categories: CategorySelectorRow[] = [];
  private hideColumns = false;

  forceRerender() {
    console.log("update called");
    this.$forceUpdate();
  }

  retrieveCategories() {
    CategoriesDataService.getCategoriesExplorerList()
      .then(response => {
        this.categories = response.data;
        this.categoriesState = State.okay;
      })
      .catch(e => {
        this.categoriesState = State.error;
        console.log(e);
      });
  }

  mounted() {
    this.retrieveCategories();
    window.addEventListener("resize", this.handleWindowResize);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  }

  handleWindowResize(event: any) {
    this.hideColumns = event.currentTarget.innerWidth < 768;
  }

  onSelect(item: CategorySelectorRow) {
    this.$router.push({
      name: "Category View",
      params: { id: item.section_letter }
    });
  }

  categoryIcon(itemId: string) {
    return `image-categories-icon-${itemId}`;
  }
}
